module.exports = __webpack_public_path__ + "static/media/KZ.a3e0ea4d.svg";